import React from 'react';
import { BilldaLogo } from '../../atoms/BilldaLogo';
import { useOrganization } from '../../../../features/organisation/hooks/useOrganization';

/**
 * Logo row for the DS SideNav header slot. The drawer close button on the
 * mobile variant is rendered by the DS SideNav itself ("Close navigation").
 */
export const SidebarHeader: React.FC = () => {
  const { data: orgData } = useOrganization();
  const orgName = orgData?.currentOrganisation?.name;

  return (
    <span className="flex min-w-0 items-center gap-2">
      <span className="-ml-1 flex shrink-0 items-center">
        <BilldaLogo variant="icon" width={24} alt="Billda" />
      </span>
      <span className="type-body-md min-w-0 truncate font-semibold text-shell-on">
        {orgName || 'Billda'}
      </span>
    </span>
  );
};
